import { apiClient } from "@/api/api-client.ts";
import createBaseService from "@/api/base-service.ts";
import type { CaseActivitySetting } from "../types/case-activity-settings";

const caseActivitySettingsService = {
	...createBaseService<CaseActivitySetting>("/case-activities-settings"),

	/**
	 * Get current case activity settings
	 */
	getCurrent: async (): Promise<CaseActivitySetting> => {
		const response = await apiClient.get("/case-activities-settings");
		return response.data.data;
	},

	/**
	 * Toggle allow_edit_filed_at setting
	 */
	toggleEditFiledAt: async (): Promise<{ message: string; allow_edit_filed_at: boolean }> => {
		const response = await apiClient.post("/case-activities-settings/toggle-edit-filed-at");
		return response.data;
	},

	/**
	 * Check if editing filed_at is allowed
	 */
	checkEditFiledAt: async (): Promise<{ allow_edit_filed_at: boolean }> => {
		const response = await apiClient.get("/case-activities-settings/check-edit-filed-at");
		return response.data;
	},
};

export default caseActivitySettingsService;
